// Modules
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Styles
import styles from './ErrorDisplay.module.scss';

// Components
import Button from './Button';
import CustomHR from './CustomHR';

const ErrorDisplay = (props) => {
  const {
    children,
    heading,
    retryCallback,
    retryButtonText = 'Try again',
    buttons = [],
  } = props;

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <span className={styles.icon}>
          <FontAwesomeIcon icon={'times-circle'} />
        </span>

        <h3>{heading}</h3>
      </header>

      <CustomHR />

      {children}

      {retryCallback ? (
        <Button
          clickHandler={retryCallback}
          text={retryButtonText}
          extraStyles={{ marginBottom: '2rem' }}
        />
      ) : null}

      {buttons}
    </div>
  );
};

export default ErrorDisplay;
